import type { CampaignSuffix } from '~clientState/hooks/useCampaignSuffix/useCampaignSuffix';

const getHeaderTextColor = (campaignSufix: CampaignSuffix) => {
  if (campaignSufix === 'C') {
    return 'primary.90';
  }
  return 'neutral.0';
};

export default getHeaderTextColor;
